import { Badge, Stack, Text, Title } from "@mantine/core";
import { default as dayjs } from "dayjs";
import { useEffect } from "react";
import { useStopwatch } from "react-timer-hook";

import { useSession } from "@/hooks/@custom/useSession";
import { EXPEDITION_SYNC_POOLING_INTERVAL } from "@/store/apis/nextcargo/_custom/sync/sync.constants";

export function LastUpdateExpedition() {
  const { expedition } = useSession();

  const today = dayjs(expedition?.timestamp).format("DD/MM/YYYY");
  const timestamp = dayjs(expedition?.timestamp);
  const tsRemaining = timestamp.add(EXPEDITION_SYNC_POOLING_INTERVAL, "milliseconds");

  const tsFromNow = timestamp.fromNow();
  const tsToNow = tsRemaining.toNow(true);

  const { reset } = useStopwatch({ autoStart: true });
  useEffect(() => {
    return reset;
  }, []);

  return (
    <Stack gap="xs">
      <Title size="xl" order={1} className="text-xl font-medium text-gray-700">
        <div className="flex items-center justify-center gap-1.5">
          <Text fw="bold" size="xl">
            Hoje,
          </Text>

          <Text size="xl">{today}</Text>
        </div>
      </Title>

      <Badge fw="normal" color="gray.6" variant="outline" component="p" size="lg" fullWidth>
        <Text size="sm">
          Última atualização: <strong> {tsFromNow || "N/A"} </strong> - Próxima atualização em: <strong> {tsToNow || "N/A"}</strong>
        </Text>
      </Badge>
    </Stack>
  );
}
